export const getReviewIdFromPath = (path: string) => {
  const arr = path.split('/');
  const indexLessOne = arr.indexOf('review-journey');
  if (indexLessOne >= 0) {
    return arr[indexLessOne + 1];
  }
  return null;
};

export const getAccountIdFromPath = (path: string) => {
  const arr = path.split('/');
  const indexLessOne = arr.indexOf('account');
  if (indexLessOne >= 0) {
    return arr[indexLessOne + 1];
  }
  return null;
};
